import { useTranslation } from "react-i18next";

import { InfoBox } from "@/components/InfoBox";
import { useLineAdsErrorMessage } from "@/pages/applications/pages/lineAdsIntegration/useLineAdsErrorMessage";

interface LineAdsLoadErrorProps {
  error: unknown;
}

export const LineAdsLoadError: React.FC<LineAdsLoadErrorProps> =
  function LineAdsLoadError({ error }) {
    const { t } = useTranslation();
    const getLineAdsErrorMessage = useLineAdsErrorMessage();

    return (
      <InfoBox
        variant="error"
        description={
          getLineAdsErrorMessage(error)?.message ??
          t(
            "applications.lineAds.error.loadFailed",
            "Couldn't load LINE Ads. Try again later.",
          )
        }
      />
    );
  };
